import { Folder } from "../../FoldersList";

export const groupFolders = (parentFolders?: Folder[], childrenFolders?: Folder[]) => {
  return parentFolders?.map((folder) => {
    return {
      ...folder,
      children: childrenFolders?.filter((item) => item.parentDirectory?.id === folder.id),
    };
  });
};
